export { GlobalDiscounts } from './globalDiscounts.component';

